import * as categories from "./categories";
import * as orders from "./orders";
import * as products from "./products";

export const dshop = {
    ...categories,
    ...orders,
    ...products
}